import { BiClipboard, BiFlag, BiGlobe, BiMailSend, BiMicrophone, BiMobile, BiSearch, BiTv, BiVideo } from "react-icons/bi";
import { FaHandshake } from "react-icons/fa";

const header = [
  {
    id: "1",
    img: "images/body/b1.jpg",
    title: " We win the tough fights.",
    details:
      "  Avio Marketing Strategies is a full-service campaign consulting and advertising firm providing an integrated basket of services to help our clients reach Fifty Plus 1 on Election Day. Since our inception, we have helped elect 31 U.S. Senators, 8 Governors, 56 Members of Congress and won 7 high-profile ballot initiatives around the country.",
  },
  {
    id: "2",
    img: "images/body/b2.jpg",
    title: " We win the tough fights.",
    details:
      "  Avio Marketing Strategies is a full-service campaign consulting and advertising firm providing an integrated basket of services to help our clients reach Fifty Plus 1 on Election Day. Since our inception, we have helped elect 31 U.S. Senators, 8 Governors, 56 Members of Congress and won 7 high-profile ballot initiatives around the country.",
  },
  {
    id: "3",
    img: "images/body/b3.jpg",
    title: " We win the tough fights.",
    details:
      "  Avio Marketing Strategies is a full-service campaign consulting and advertising firm providing an integrated basket of services to help our clients reach Fifty Plus 1 on Election Day. Since our inception, we have helped elect 31 U.S. Senators, 8 Governors, 56 Members of Congress and won 7 high-profile ballot initiatives around the country.",
  },
];

const testimonials = [
  {
    id: "1",
    img: "images/body/c1.jpg",
    name: "  Jhon Delanis",
    title: "CEO",
    feedback:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s",
  },
  {
    id: "2",
    img: "images/body/c1.jpg",
    name: "  Jhon Delanis",
    title: "CEO",
    feedback:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s",
  },
];

const services = [
  {
    id: "1",
    icon: <BiVideo />,
    title: " Advertising & Production",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "2",
    icon: <BiMobile />,
    title: " Digital",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "3",
    icon: <FaHandshake />,
    title: " General Consulting",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "4",
    icon: <BiTv />,
    title: " Media Buying",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "5",
    icon: <BiMailSend />,
    title: " Direct Mail",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "6",
    icon: <BiFlag />,
    title: " Field",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "7",
    icon: <BiSearch />,
    title: " Research",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "8",
    icon: <BiMicrophone />,
    title: " Communications",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "9",
    icon: <BiClipboard />,
    title: " Ballot Initiatives",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "10",
    icon: <BiGlobe />,
    title: "International Campaigns",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
];

const clients = [
  {
    id: "1",
    img: "images/brand/c1.png",
  },
  {
    id: "2",
    img: "images/brand/c2.png",
  },
  {
    id: "3",
    img: "images/brand/c3.png",
  },
  {
    id: "4",
    img: "images/brand/c4.png",
  },
  {
    id: "5",
    img: "images/brand/c1.png",
  },
  {
    id: "6",
    img: "images/brand/c5.png",
  },
  {
    id: "7",
    img: "images/brand/c6.png",
  },
  {
    id: "8",
    img: "images/brand/c7.png",
  },
  {
    id: "9",
    img: "images/brand/c2.png",
  },
  {
    id: "10",
    img: "images/brand/c3.png",
  },
  {
    id: "11",
    img: "images/brand/c4.png",
  },
  {
    id: "12",
    img: "images/brand/c1.png",
  },
  {
    id: "13",
    img: "images/brand/c2.png",
  },
  {
    id: "14",
    img: "images/brand/c3.png",
  },
  {
    id: "15",
    img: "images/brand/c4.png",
  },
];

const studies = [
  {
    id: "1",
    img: "images/brand/c1.png",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "2",
    img: "images/brand/c2.png",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "3",
    img: "images/brand/c3.png",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
  {
    id: "4",
    img: "images/brand/c4.png",
    details:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, quia minus! Provident culpa, facilis explicabo, aspernatur temporibus, dolorem impedit atque nihil repellendus facere debitis",
  },
];

export { header, testimonials, services, clients, studies };
